import React, { useContext, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import LoadingBar from "react-top-loading-bar";
import { toastError } from "../../../../shared/helpers";

import ActionPageHero from "../../../molecules/ActionPageHero";

import Stepper from "../../../molecules/Stepper/Stepper";
import CreateServiceSuccessModal from "../../../organisms/CreateServiceSuccessModal";
import EditProgramFormOne from "../../../templates/EditProgramForms/form.one";
import EditProgramFormThree from "../../../templates/EditProgramForms/form.three";
import EditProgramFormTwo from "../../../templates/EditProgramForms/form.two";
import { demoContext } from "../../../../shared/store/contexts";

const EditProgramPage = () => {
  const { id: orgId, serviceId } = useParams();
  const { services } = useContext(demoContext);
  const loader = useRef(null);
  const navigate = useNavigate();

  const service = services?.find((i) => i.id === serviceId);

  const [step, setStep] = useState(1);
  const [fields, setFields] = useState({});
  const [submitted, setSubmitted] = useState(false);

  const updateFields = (data) => setFields({ ...fields, ...data });

  const discardData = () => {
    navigate(`/dashboard/organization/${orgId}/programs`);
  };

  const submitForm = (data, mode = "publish") => {
    updateFields(data);

    toastError("Cannot perfom this action on Demo mode");
  };

  return (
    <main className="flex flex-col w-full relative">
      <LoadingBar height={2} color="#00AF72" ref={loader} />
      <div className="flex justify-between items-center">
        <ActionPageHero
          className="organization-container"
          title="Edit Service"
          description="Edit existing service"
          back
          goBackText="Back to All Services"
        />
      </div>
      <section className="relative">
        <div className="w-2/5 mx-auto mt-10 mb-6">
          <Stepper
            activeStep={step}
            disableClick
            steps={[
              {
                value: 1,
              },
              {
                value: 2,
              },
              {
                value: 3,
              },
            ]}
            changeStep={setStep}
          />
        </div>

        <div className="">
          {step === 1 && (
            <EditProgramFormOne
              changeStep={setStep}
              fields={service}
              updateFields={updateFields}
              saveToDraft={(data) => submitForm(data, "draft")}
              discard={discardData}
            />
          )}
          {step === 2 && (
            <EditProgramFormTwo
              changeStep={setStep}
              fields={service}
              updateFields={(data) => updateFields(data)}
              saveToDraft={(data) => submitForm(data, "draft")}
              discard={discardData}
            />
          )}
          {step === 3 && (
            <EditProgramFormThree
              changeStep={setStep}
              fields={service}
              saveToDraft={(data) => submitForm(data, "draft")}
              updateFields={(data) => submitForm(data)}
              discard={discardData}
            />
          )}
        </div>
      </section>
      {submitted && (
        <CreateServiceSuccessModal
          message="Updated"
          closeModal={() =>
            (window.location.pathname = `/dashboard/organization/${orgId}/programs`)
          }
        />
      )}
    </main>
  );
};

export default EditProgramPage;
